import { createAction } from 'redux-actions'

const RESET_PROFILE = 'RESET_PROFILE'
const SET_PROFILE = 'SET_PROFILE'

const actions = {
    resetProfile: createAction(RESET_PROFILE),
    setProfile: createAction(SET_PROFILE)
}

const types = {
    RESET_PROFILE,
    SET_PROFILE
}

export { actions, types }



// WEBPACK FOOTER //
// ./src/store/actions/profiles.js